type TreeProject = {
  folders?: Array<{ id: string; collapsed?: boolean }>;
  getRootTree: () => unknown;
};

type TreeDocument = {
  id: string;
  parentId?: string;
  displayOrder?: number;
  title?: string;
};

export function getProjectTreeSyncKey(project: TreeProject, contents: TreeDocument[] = []) {
  return JSON.stringify({
    tree: project.getRootTree(),
    documentIds: contents.map((document) => [document.id, document.parentId ?? "none", document.displayOrder ?? 0, document.title ?? ""]),
    folderCollapsed: (project.folders || []).map((folder) => [folder.id, folder.collapsed ?? false]),
  });
}
